<template>
    <div class="card centered-form" style="position: relative">
        <h1>
            Create a Trip
        </h1>
        <back-link>
            <i class="fa fa-close fa-fw fa-2x" style="position: absolute; right: 0; top: 0;" title="Cancel"></i>
        </back-link>
        <p v-if="Object.keys(errors).length > 0" class="errorSection">
            <span v-if="Object.keys(errors).length > 1" class="errorsTitle">
                Errors:
            </span>
            <span v-else class="errorsTitle">
                Error:
            </span>
            <ul class="errorsList">
                <li v-for="(error, key) in errors" :key="key">
                    {{ error }}
                </li>
            </ul>
        </p>
        <table>
            <tr id="mgr_requested">
                <td>
                    <span>
                        <b>Requesting Manager:</b>
                    </span>
                </td>
                <td>
                    <user-select @change="trip.mgr_requested = $event; clearError()" :currentValue="$privateReactiveStore.getManager(trip.mgr_requested)" :options="managers" :defaultSelection="user && user.id"></user-select>
                </td>
            </tr>
            <tr>
                <td>
                    <span>
                        <b>Stock Number:</b>
                    </span>
                </td>
                <td>
                    <vehicle-select @change="trip.stock_num = $event" :currentValue="trip.stock_num"></vehicle-select>
                </td>
            </tr>
            <tr>
                <td>
                    <span>
                        <b>Vehicle From:</b>
                    </span>
                </td>
                <td>
                    <location-select @change="trip.from = $event" :currentValue="trip.from" :readonly="false"></location-select>
                </td>
            </tr>
            <tr>
                <td>
                    <span>
                        <b>Vehicle To:</b>
                    </span>
                </td>
                <td>
                    <location-select @change="trip.to = $event" :currentValue="trip.to"></location-select>
                </td>
            </tr>
            <tr>
                <td>
                    <b>Skip car wash?</b>
                </td>
                <td>
                    <v-input type="checkbox" @change="trip.skip_wash = $event" :currentValue="trip.skip_wash"> 
                        Yes
                    </v-input>
                </td>
            </tr>
            <tr>
                <td>
                    <b>Product Specialist on the way?</b>
                </td>
                <td>
                    <v-input type="checkbox" @change="onMyWay = $event" :currentValue="onMyWay"> 
                        Yes
                    </v-input>
                </td>
            </tr>
            <tr>
                <td>
                    <b>Product Specialist:</b>
                </td>
                <td>
                    <user-select @change="trip.driver = trip.product_specialist = $event" :currentValue="$privateReactiveStore.getProductSpecialist(trip.product_specialist)" :options="productSpecialists"></user-select>
                </td>
            </tr>
            <tr>
                <td>Guest Name:</td>
                <td>
                    <v-input type="text" @change="trip.guest_name = $event" :currentValue="trip.guest_name"></v-input>
                </td>
            </tr>
            <tr>
                <td>
                    Appt Time:
                </td>
                <td>
                    <appt-time editonly :currentValue="trip.appt_time" @change="trip.appt_time = $event"></appt-time>
                </td>
            </tr>
            <tr>
                <td>
                    <b>Guest Waiting?</b>
                </td>
                <td>
                    <v-input type="checkbox" @change="trip.waiter = $event" :currentValue="trip.waiter">
                        Yes
                    </v-input>
                </td>
            </tr>
            <template v-if="trip.waiter && !onMyWay">
                <tr>
                    <td>
                        <b>Deliver to Product Specialist:</b>
                    </td>
                    <td>
                        <user-select @change="trip.product_specialist = $event" :currentValue="$privateReactiveStore.getProductSpecialist(trip.product_specialist)" :options="productSpecialists"></user-select>
                    </td>
                </tr>
            </template>
            <template v-if="!onMyWay">
                <tr>
                    <td>
                        Driver:
                    </td>
                    <td>
                        <user-select @change="driver = $event" :currentValue="$privateReactiveStore.getDriver(driver)" :options="drivers"></user-select>
                    </td>
                </tr>
            </template>
            <tr>
                <td colspan=2>
                    <label>
                        Note:
                        <trip-note @change="trip.note = $event" :note="dummy_note"></trip-note>
                    </label>
                </td>
            </tr>
            <tr>
                <td colspan=2>
                    <v-button @click="createTrip" :style="{width: '100%'}">
                        <i class="fa fa-file-o"></i>&nbsp;Create Trip
                    </v-button>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    import _ from 'lodash'
    import epoch from 'epoch.js'
    import bool from 'normalize-bool'
    import BackLink from './BackLink.vue'
    import UserSelect from './UserSelect.vue'
    import VehicleSelect from './VehicleSelect.vue'
    import LocationSelect from './LocationSelect.vue'
    import ApptTime from './ApptTime.vue'
    import TripNote from './TripNote.vue'

    const coerceTrip = function (q) {
      if (q.stock_num) q.stock_num = String(q.stock_num)
      if (q.from) q.from = String(parseInt(q.from))
      if (q.to) q.to = String(parseInt(q.to))
      if (q.driver) q.driver = parseInt(q.driver)
      if (q.mgr_requested) q.mgr_requested = parseInt(q.mgr_requested)
      if (q.product_specialist) q.product_specialist = parseInt(q.product_specialist)
      if (q.waiter) q.waiter = bool(q.waiter)
      if (q.skip_wash) q.skip_wash = bool(q.skip_wash)
      if (q.guest_name) q.guest_name = String(q.guest_name)
    }

    export default {
        data () {
            return {
                onMyWay: false,
                dummy_note: {
                    note: ''
                },
                driver: null,
                trip: {
                    stock_num: '',
                    from: '5',
                    to: 0,
                    eta: null,
                    dispatcher: null, //int
                    mgr_requested: null, // int
                    product_specialist: 0, //int
                    pickup: null, // datetime
                    delivered: null, // datetime
                    waiter: false,
                    note: '',
                    skip_wash: false,
                    guest_name: null,
                    appt_time: undefined
                },
                errors: {}
            }
        },
        components: {
            'back-link': BackLink,
            'user-select': UserSelect,
            'vehicle-select': VehicleSelect,
            'location-select': LocationSelect,
            'appt-time': ApptTime,
            'trip-note': TripNote
        },
        mounted() {
            this.$eventHub.$on('createTripErrors', this.createTripErrors);
            
            if(this.$privateReactiveStore.getUser().role == 'sales_manager') {
                this.trip.mgr_requested = this.$privateReactiveStore.getUser().id;
            }
        },
        destroyed() {
            this.$eventHub.$off('createTripErrors');
        },
        methods: {
            createTrip () {
                if(this.trip.mgr_requested == null) {
                    this.errors = {'mgr_requested':  "Requesting Manager id Required."};

                    if(!document.getElementById('mgr_requested').classList.contains('errorsList')) {
                        document.getElementById('mgr_requested').classList.add('errorsList');
                    }
                }

                if(Object.keys(this.errors).length == 0) {
                    if (this.trip.appt_time ) {
                        this.trip.appt_time = epoch(this.trip.appt_time).datetime()
                    }
                    
                    if (this.driver) {
                        this.trip.drivers = [parseInt(this.driver)];
                        this.trip.assigned_time = epoch().datetime();
                        this.trip.dispatcher = this.$privateReactiveStore.getUser().id; 
                        this.trip.transit_action_stage = 1;
                    }
                    
                    this.$eventHub.$emit('createTrip', this.trip);
                }
                else {
                    console.log("ERRORS FOUND " + JSON.stringify(this.errors));
                }
            },
            createTripErrors(createErrors) {
                //TODO need to loop through returned errors and make the message user friendly;
                if(Object.keys(createErrors).includes('mgr_requested')) {
                    createErrors['mgr_requested'] = "Requesting Manager is Required.";

                    if(!document.getElementById('mgr_requested').classList.contains('errorsList')) {
                        document.getElementById('mgr_requested').classList.add('errorsList');
                    }
                }

                this.errors = createErrors;
            },
            clearError(event) {
                //TODO LOOP THROUGH LIST OF ERRORS AND REMOVE IDENTIFYING CSS
                document.getElementById('mgr_requested').classList.remove('errorsList');

                this.errors = {};
            }
        },
        computed: {
            managers () {
                return this.$privateReactiveStore.getManagers()
            },
            user () {
                return this.$privateReactiveStore.getUser()
            },
            productSpecialists () {
                let a = this.$privateReactiveStore.productSpecialists.slice()
                let b = this.$privateReactiveStore.managers.slice()
                let c = a.concat(b);

                c = c.filter((ps,index) => {
                    let foundIndex = c.findIndex(object => {
                        return object.id === ps.id;
                    })
                    
                    return (foundIndex == index);
                });
                
                c.sort(function(a, b){
                    var nameA=a.first_name.toLowerCase(), nameB=b.first_name.toLowerCase()
                    if (nameA < nameB) //sort string ascending
                        return -1 
                    if (nameA > nameB)
                        return 1
                    return 0 //default return value (no sorting)
                })
                
                return c
            },
            drivers () {
                let drivers = []

                // Allow picking the product specialist as a driver
                if (this.trip.product_specialist) {
                    let ps = this.$privateReactiveStore.getProductSpecialist(this.trip.product_specialist);
                    drivers.push(ps)
                }

                // Insert a separator between drivers and backup drivers
                drivers.push({
                    diabled: "1",
                    full_name: '──── Primary Drivers ────',
                    id: -1,
                })
                
                // Add all drivers one by one
                let separatorAlready = false

                for (let i = 0; i < this.$privateReactiveStore.drivers.length; i++) {
                    if (!separatorAlready && this.$privateReactiveStore.drivers[i].role !== 'driver') {
                        // Insert a separator between drivers and backup drivers
                        drivers.push({
                            diabled: "1",
                            full_name: '──── Backup Drivers ────',
                            id: -2,
                        })
                        
                        separatorAlready = true
                    }

                    drivers.push(this.$privateReactiveStore.drivers[i])
                }

                return drivers
            }
        },
    }
</script>

<style scoped>
    h1 {
        text-align: center;
        padding-top: 0;
    }

    .halfsies>div {
        width: 50%;
        float: left;
    }

    .centered-form {
        min-width: -moz-fit-content;
        min-width: fit-content;
        max-width: 600px;
        margin: auto;
        margin-top: 1em;
        padding: 2em;
        overflow: visible;
    }

    .centered-form * {
        flex: 1;
    }

    .errorSection {
        color: red;
    }

    .errorsTitle {
        font-weight: bold;
    }

    .errorsList {
        font-style: italic;
        color: red;
    }
</style>